import { render, staticRenderFns } from "./attachment-info.html?vue&type=template&id=0865f1c2&scoped=true&external"
import script from "./attachment-info.js?vue&type=script&lang=js&external"
export * from "./attachment-info.js?vue&type=script&lang=js&external"
import style0 from "./attachment-info.scss?vue&type=style&index=0&id=0865f1c2&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0865f1c2",
  null
  
)

export default component.exports